export default {
  currentPageTitle(state) {
    return state.currentMenu.title;
  },
  currentActiveMenu(state) {
    return state.currentMenu.url;
  },
  userType(state) {
    return state.userInfo.type;
  },
  permissions(state) {
    return state.permissions;
  },
  roles(state) {
    return state.roles;
  },
  timeShowForWarehouse(state) {
    return state.timeShowForWarehouse;
  },
};



// WEBPACK FOOTER //
// ./src/store/getters.js